export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="mt-24 border-t border-slate-200 px-4 pb-12 pt-10 sm:px-6 dark:border-slate-800">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-3 text-center sm:flex-row sm:text-left">
        <p className="m-0 text-sm text-slate-600 dark:text-slate-400">
          &copy; {year} Lugstash. All rights reserved.
        </p>
        <p className="m-0 font-mono text-[0.62rem] font-semibold uppercase tracking-[0.16em] text-slate-400 dark:text-slate-500">
          Smart parcel lockers
        </p>
      </div>
    </footer>
  )
}
